"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var DEFAULTS = {
  gates: new _immutable.Set(),
  portal: new _immutable.Map(),
  session: new Date().valueOf(),
  user: new _immutable.Map()
};

var Auth = /*#__PURE__*/function (_Record) {
  (0, _inherits2.default)(Auth, _Record);

  function Auth() {
    (0, _classCallCheck2.default)(this, Auth);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Auth).apply(this, arguments));
  }

  (0, _createClass2.default)(Auth, null, [{
    key: "fromJS",
    value: function fromJS(data) {
      return new Auth({
        gates: new _immutable.Set(data.gates),
        portal: (0, _immutable.fromJS)(data.portal),
        session: data.session,
        user: (0, _immutable.fromJS)(data.user)
      });
    }
  }]);
  return Auth;
}((0, _immutable.Record)(DEFAULTS));

exports.default = Auth;
module.exports = exports.default;